module.exports = __webpack_public_path__ + "img/2-3.d69e23e7.svg";